import * as AlfredoStyles from "../../styles/global/global";
import * as AlfredoComponents from "../../components";

const ReportPage: React.FC = () => {
  return (
    <AlfredoStyles.Container>
      <AlfredoComponents.Breadcrumb />
      <AlfredoStyles.FlexContainer>
        <AlfredoStyles.FlexItem>
          <AlfredoComponents.Report />
        </AlfredoStyles.FlexItem>
      </AlfredoStyles.FlexContainer>
    </AlfredoStyles.Container>
  );
};

export default ReportPage;
